export default "__VITE_ASSET__ede6a99f__"